export default "__VITE_ASSET__79523f5f__"